/** @format */

import { createContext } from 'react';

export const MorabishoooContext = createContext({
	authUser: {},
	authRoles: [],
});
